import { render, staticRenderFns } from "./Precruit.vue?vue&type=template&id=07f42c6e&scoped=true&"
import script from "./Precruit.vue?vue&type=script&lang=ts&"
export * from "./Precruit.vue?vue&type=script&lang=ts&"
import style0 from "./Precruit.vue?vue&type=style&index=0&id=07f42c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f42c6e",
  null
  
)

export default component.exports